import axios from 'axios';

import { UnauthorizedType } from '../types/UnauthorizedType';

import headers from '../headers.json';

type SuccessType = {
  status: number;
  data: {
    decoded_token: {
      name: string;
      email: string;
      groups: Array<string>;
    };
  };
};

export type LoginPromiseType =
  | { data: SuccessType; success: boolean }
  | { data: UnauthorizedType; success: boolean }
  | { data: null; success: boolean };

const LOGIN = async (): Promise<LoginPromiseType> => {
  try {
    const serverUrl = process.env.REACT_APP_SERVER_URL_BACKEND_API;
    if (!serverUrl) throw Error('Backend-URL not defined.');

    const url = `${serverUrl}/auth/status`;

    const response = await axios.get<SuccessType | UnauthorizedType>(url, {
      headers: {
        ...headers,
      },
      withCredentials: true,
    });

    if (response.status === 200) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.log(error);
    if (axios.isAxiosError(error)) {
      window.location.href = `${process.env.REACT_APP_SERVER_URL_BACKEND_API}/login/`;
    }

    return { success: false, data: null };
  }
};

export default LOGIN;
